import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import VideoCard from "./VideoCard";
import "./VideoFeed.css";
import { useInstitution } from "../contexts/InstitutionContext";

const PasswordPrompt = ({ onSubmit, error }) => {
  const [password, setPassword] = React.useState("");
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    await onSubmit(password);
    setIsSubmitting(false);
  };

  return (
    <div className="enter-screen">
      <div className="enter-content">
        <h1>Institution Access</h1>
        <p>Enter password to access this coaching moment</p>

        <form
          onSubmit={handleSubmit}
          style={{ marginTop: "20px", width: "100%" }}
        >
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter password"
            required
            disabled={isSubmitting}
            style={{
              width: "100%",
              padding: "12px",
              fontSize: "16px",
              border: "1px solid #ccc",
              borderRadius: "8px",
              marginBottom: "10px",
            }}
          />

          {error && (
            <div
              style={{
                color: "#d32f2f",
                fontSize: "14px",
                marginBottom: "10px",
                padding: "10px",
                backgroundColor: "#ffebee",
                borderRadius: "4px",
              }}
            >
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={isSubmitting}
            className="enter-button"
          >
            {isSubmitting ? "Authenticating..." : "Access Moment"}
          </button>
        </form>
      </div>
    </div>
  );
};

function SnippetView() {
  const {
    snippets,
    isLoading,
    error,
    showPasswordPrompt,
    handlePasswordSubmit,
  } = useInstitution();
  const [searchParams] = useSearchParams();
  const snippetId = searchParams.get("snippet");
  const [snippet, setSnippet] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (snippets.length > 0 && snippetId) {
      const foundSnippet = snippets.find((s) => s.uid === snippetId);
      if (foundSnippet) {
        setSnippet(foundSnippet);
        setNotFound(false);
      } else {
        setSnippet(null);
        setNotFound(true);
      }
    }
  }, [snippets, snippetId]);

  if (showPasswordPrompt) {
    return <PasswordPrompt onSubmit={handlePasswordSubmit} error={error} />;
  }

  if (isLoading) {
    return (
      <div className="loading">
        <div className="loading-spinner"></div>
        <p>Loading coaching moment...</p>
      </div>
    );
  }

  if (error && !showPasswordPrompt) {
    return (
      <div className="enter-screen">
        <div className="enter-content">
          <h1>Error</h1>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  if (notFound || !snippet) {
    return (
      <div className="enter-screen">
        <div className="enter-content">
          <h1>Snippet Not Found</h1>
          <p>The requested coaching moment could not be found.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="video-feed snippet-view">
      <VideoCard snippet={snippet} isActive={true} />
    </div>
  );
}

export default SnippetView;
